// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Dialog/Dialog.less
// module id = 198
// module chunks = 2